import {httpGet, httpPatch} from './http.service';

export interface ArchivedPresentation {
    _id: string;
    name: string;
}

const BASE_URL = 'editor/archived-presentations';

export function fetchArchivedPresentations(
    search: string,
    page: number,
    pageSize: number
): Promise<{items: ArchivedPresentation[]; total: number}> {
    return httpGet(BASE_URL, {params: {search, page, pageSize}});
}

export function restoreArchivedPresentation(id: string): Promise<void> {
    return httpPatch(`${BASE_URL}/${id}/restore`);
}
